import { Component, Input, OnChanges } from '@angular/core'
import { ChartData, ChartEvent, ChartOptions, plugins } from 'chart.js'

import { AggregationDataset } from '../../../shared/interfaces/visualizations/aggregation-dataset.interface'
import { ColorService } from '../../../shared/services/color.service'
import { SmartLinkService } from '../../../shared/services/smart-link.service'
import { PieChartItem } from './interfaces/pie-chart-item'

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements OnChanges {
  @Input() dataset: AggregationDataset

  pieChartOptions: ChartOptions<'pie'> = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom'
      }
    }
  }

  pieChartData: ChartData<'pie', number[], string | string[]>

  constructor(private smartLinkService: SmartLinkService) {}

  ngOnChanges(): void {
    const colors: string[] = ColorService.getColors()
    this.pieChartData = {
      labels: this.dataset.data.map((d: PieChartItem) => d.label),
      datasets: [
        {
          data: this.dataset.data.map((d: PieChartItem) => d.count),
          backgroundColor: this.dataset.data.map(
            (d: PieChartItem, i: number) => colors[i]
          ),
          borderColor: this.dataset.data.map(
            (d: PieChartItem, i: number) => colors[i]
          )
        }
      ]
    }
  }

  chartClicked(event: {
    event?: ChartEvent
    active?: ({ index: number } | any)[]
  }): void {
    const clickedItem: PieChartItem = this.dataset.data[event.active[0].index]

    if (clickedItem?.link) {
      this.smartLinkService.goToLink(clickedItem.link)
    }
  }
}
